import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCj57WhUUn1npey7BowCopbAwBxmmRI4So",
    authDomain: "tide-analyzer.firebaseapp.com",
    projectId: "tide-analyzer",
    storageBucket: "tide-analyzer.firebasestorage.app",
    messagingSenderId: "376556201945",
    appId: "1:376556201945:web:dd7b5c582f8537d6949bc8",
    measurementId: "G-7PRLCC1XGE"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);